import React, { Component } from 'react';
import Iframe from 'react-iframe';
import { Label } from 'atoms/Texts';
import { ButtonReg } from 'atoms/Buttons';
import IconPng from 'atoms/IconPng';
import Breadcrumb from 'molecules/Breadcrumb';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  PageWrapper,
  RoundedWrapper,
  IframeWrapper,
  EmptyWrapper,
  FilterCol,
  FilterRow,
} from './styles';
import { withTheme } from 'styled-components';
import moment from 'moment';
import { MonthYearInput } from 'components/molecules/DateTimeInput/index';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import lo from 'lodash'

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_folder = require('App/assets/images/ic_folder.png')

class ReportTripCount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: {
        PERIOD: new Date(),
        SITE: '-',
      },
      reportUri: null,
      navList: [
        'Report',
        'Trip Count'
      ],
    }
  }

  // change filter state
  onFilterChange(val, field) {
    const filterObj = Object.assign(this.state.filter)
    filterObj[field] = val
    this.setState({ filter: filterObj })
  }

  // view report based on filter
  onFilterSubmit() {
    const { filter } = this.state
    const REPORT_URL = process.env.REPORT_URL

    this.setState({
      reportUri: `${REPORT_URL}TRIP_COUNT&DATE=${moment(filter.PERIOD).format('YYYY-MM-01')}${filter.SITE !== '-' ? `&SITE=${filter.SITE}` : ''}&rs:Command=Render&rc:Parameters=${process.env.SHOW_REPORT_PARAMS}`
    })
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }
    const { filter } = this.state
    const { lookups } = this.props

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Period
          </Label>
          <MonthYearInput
            fn={this.onFilterChange.bind(this)}
            val={filter.PERIOD}
            config={inputConfig}
            field={'PERIOD'}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Site
          </Label>
          <FormSelect
            placeholder={'Select site'}
            onChangeVal={e => this.onFilterChange(e.target.value, 'SITE')}
            options={lookups.site}
            value={filter.SITE}
            valField={'name'}
            dispField={'name'}
            arrowSize={'3%'}
            {...inputConfig}
          />
        </FilterCol>
        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
        />
      </FilterRow>
    )
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  render() {
    const { navList, reportUri } = this.state
    const { viewState: { isLoading, isMobileView } } = this.props

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        {!isLoading &&
          <RoundedWrapper>
            {this.renderFilterRow()}
            <div className={'col-12 px-0 pt-3 text-center'}>
              {reportUri ?
                <IframeWrapper>
                  <Iframe
                    url={reportUri}
                    width="100%"
                    height={this.getIframeHeight()}
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative" />
                </IframeWrapper> :
                <EmptyWrapper>
                  <div>
                    <IconPng srcIcon={ic_folder} size={'auto'} h={'86'} mb={'20px'} />
                  </div>
                  <Label weight={'600'} lineheight={'14px'} mb={'35px'} size={'12px'}>
                    Select “filter” and click “view” button to see the report
                  </Label>
                </EmptyWrapper>
              }
            </div>
          </RoundedWrapper>
        }
      </PageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  lookups.site = lo.uniqBy(state.userLogin.userDetail.allowedCompanies.map((d) => ({ name: d.workLocation.name })),
  'name',
  )
  return {
    viewState: state.viewState,
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportTripCount)
);
